
import React from 'react';
import { Plus, Sparkle } from 'lucide-react';
import { getConfettiColors } from '@/utils/gamification';

interface GamificationAnimationsProps {
  showAnimation: boolean;
  showMedalAnimation: boolean;
  earnedPoints: number;
  medal: {
    name: string;
    emoji: string;
  };
  streak: number;
}

const GamificationAnimations: React.FC<GamificationAnimationsProps> = ({
  showAnimation,
  showMedalAnimation,
  earnedPoints,
  medal,
  streak
}) => {
  if (!showAnimation) return null;
  
  const confettiColors = getConfettiColors(streak);
  
  return (
    <div className="absolute inset-0 flex items-center justify-center z-30 pointer-events-none">
      <div className="relative flex flex-col items-center">
        {/* Confetti animation */}
        <div className="confetti-container">
          {Array.from({ length: 30 }).map((_, i) => (
            <div 
              key={i}
              className={`confetti-piece`}
              style={{
                left: `${Math.random() * 100}%`,
                width: `${5 + Math.random() * 10}px`,
                height: `${5 + Math.random() * 10}px`,
                animationDelay: `${Math.random() * 0.5}s`,
                animationDuration: `${0.5 + Math.random() * 1}s`,
                backgroundColor: confettiColors[i % confettiColors.length]
              }}
            />
          ))}
        </div>
        
        {/* Points earned animation */}
        <div className="text-3xl font-bold text-hormony-coral animate-scale-in flex items-center justify-center">
          <Plus size={24} className="mr-1" />
          <span>{earnedPoints}</span>
        </div>

        <div className="text-lg text-hormony-charcoal mt-2 animate-scale-in">
          Points Earned!
        </div>
        
        {/* Medal animation */}
        {showMedalAnimation && (
          <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center animate-scale-in" style={{ animationDelay: '1s' }}>
            <div className="bg-white p-4 rounded-xl shadow-lg border border-hormony-beige flex flex-col items-center">
              <div className="text-4xl mb-2">
                {medal.emoji}
              </div>
              <div className="text-xl font-bold text-hormony-coral">
                {medal.name} Medal!
              </div>
              <div className="text-sm text-hormony-charcoal mt-1 text-center">
                {streak} day streak achieved!
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GamificationAnimations;
